<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '70vh'}" styleClass="custombar1" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <ng-container *ngIf="!running; else runningTemplate">
      <!-- <ng-container *ngTemplateOutlet="dossierListTemplate"></ng-container> -->
      <div class="row">
        <div class="col-12 alert alert-info">
          <i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i>
          <span [innerHTML]="action.description">
          </span>
        </div>

        <ng-container *ngIf="!isButtonMode()">
          <div class=" col-12 m-t-xs">
            <div *ngIf="action && action.parameters">
              <div class="form-group" *ngFor="let parameter of action.parameters">
                <formElement [model]="model" [fieldConfig]="createFieldConfig(parameter)">
                </formElement>
                <button *ngIf="parameter.name === 'TARGET' && !action.target?.identifier && action.needsPreparation"
                  class="btn btn-primary btn-xs  float-right m-b-md" appNoDblClick (click)="prepareAction()"
                  type="button"><i class="fas fa-search"></i> </button>
                <!--
            <label class="col-sm-12 col-form-label col-form-label-sm"
              [attr.for]="parameter.identifier">{{parameter.description}}</label>
            <div class="col-sm-12">
              <input id="{{parameter.identifier}}" type="text" class="form-control" placeholder="{{parameter.tooltip}}"
                autocomplete="off" alt="{{parameter.tooltip}}" />
            </div>-->
              </div>
            </div>
          </div>

          <div class="col-12 m-t-xs text-center">
            <strong class="text-danger">{{'Actions.exec.confirmation' | translate}}</strong>
          </div>
          <div class="col-12 d-flex justify-content-center m-b-md m-t-md">
            <div class="btn-group-xs">
              <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick (click)="execute()" type="button">
                <i class="fa fa-check"></i> {{'General.accept' | translate}}</button>
              <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="close()" type="button">
                <i class="fas fa-times"></i> {{'General.cancel' | translate}}</button>
            </div>
          </div>

        </ng-container> <!-- fin !isButtonMode()-->

        <ng-container *ngIf="isButtonMode()">
          <!-- Si existe un parametro de forma que su formFieldType es tipo BUTTON y tiene posibles valores no lo gestionamos como un combo,
          por cada posible valor tendremos un boton-->

          <div class=" col-12 m-t-xs">
            <div *ngIf="action && action.parameters">
              <div class="form-group" *ngFor="let parameter of action.parameters">
                <!--<ng-container *ngIf="parameter?.formFieldType !== 'BUTTON' && parameter?.name!=='taskId'">-->
                <ng-container *ngIf="parameter?.formFieldType !== 'BUTTON'">
                  <formElement [model]="model" [fieldConfig]="createFieldConfig(parameter)">
                  </formElement>
                </ng-container>
              </div>
            </div>
          </div>

          <div class=" col-12 m-t-xs text-center">
            <!--<strong class="text-danger">{{'Actions.exec.confirmation' | translate}}</strong>-->
            <strong class="text-danger">¿Qué operación desea realizar?</strong>
          </div>
          <div class="col-12 d-flex justify-content-center m-b-md m-t-md">
            <div class="btn-group-xs">
              <ng-container *ngIf="action && action.parameters">
                <ng-container *ngFor="let parameter of action.parameters">
                  <ng-container *ngIf="parameter?.formFieldType === 'BUTTON' && parameter?.possibleValues">
                    <ng-container *ngFor="let possibleValue of parameter.possibleValues">
                      <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick
                        (click)="execute(parameter, possibleValue)" type="button">
                        <!--<i class="fa fa-check"></i> --> {{possibleValue.description}}</button>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick (click)="close()" type="button">
                <i class="fas fa-times"></i> {{'General.cancel' | translate}}</button>
            </div>
          </div>

        </ng-container> <!-- fin isButtonMode-->
      </div>
    </ng-container>
  </div>

</p-scrollPanel>

<p-dialog [(visible)]="showWarningMessage" [showHeader]="true" header="Aviso" [closeOnEscape]="true" [modal]=" true"
  [draggable]="false" [appendTo]="'body'" [responsive]="true" [focusOnShow]="true">
  <sub-header [isModal]="true" [windowHash]=windowHashMessage [includeContextHelp]="false"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
    <div class="container-fluid">
      <div class="row">
        <div class="alert alert-info  col-12 p-5">
          <!--<span #messageContainer [innerHtml]="this.sanitizer.bypassSecurityTrustHtml(this.warningMessage)"></span>-->
          <span #messageContainer [innerHtml]="this.warningMessage"></span>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>
<ng-template #runningTemplate>
  <!-- RESULTADO FINAL DE LA EJECUCION -->
  <div class="row  mb-2" *ngIf="showFinalResult">
    <div class="col-12">
      <div class="widget-container col-12 col-md-4">
        <div class="widget row style1 bg-info text-light">
          <div class="col-4" style="display:inline-block;">
            <i class="fas fa-3x fa-list"></i>
          </div>
          <div class="col-8 float-right">
            <span>Seleccionados</span>
            <h2 class="font-bold">{{totalSeleccionados}}</h2>
          </div>
        </div>
      </div>
      <div class="widget-container col-12 col-md-4">
        <div class="widget row style1 bg-success text-light">
          <div class="col-4" style="display:inline-block;">
            <i class="fas fa-3x fa-check"></i>
          </div>
          <div class="col-8 float-right">
            <span>Procesados</span>
            <h2 class="font-bold">{{totalProcesados}}</h2>
          </div>
        </div>
      </div>
      <div class="widget-container col-12 col-md-4">
        <div class="widget row style1 bg-danger text-light">
          <div class="col-4" style="display:inline-block;">
            <i class="fas fa-3x fa-ban"></i>
          </div>
          <div class="col-8 float-right">
            <span>Errores</span>
            <h2 class="font-bold">{{totalErrores}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row  mb-2">
    <div class="col-12 alert alert-info">
      <div class="col-12">
        <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{
          actionExecutionResult.description }} </span>
      </div>
      <div class="col-12">
        <p-progressBar [value]="actionExecutionResult.completionPercentage"></p-progressBar>
      </div>
    </div>
  </div>
  <!-- TABLE DE TARGETS -->
  <div class="row mb-2">
    <div class="col-12">
      <p-table #dt [value]="actionExecutionResult.executions">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-icon text-center">-</th>
            <th>Expediente</th>
            <th>Estado</th>
            <!-- <th>Estado</th> -->
            <th style="width: 60px;" class="text-right">Progreso</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-action>
          <tr>
            <td class="col-icon text-center" style="cursor:pointer;">
              <span (click)="showActionExecutionWayPoints (action)"><i class="{{getStatusIcon (action)}}"></i></span>
            </td>
            <td>{{action?.target?.description}}</td>
            <td>{{action?.message}}</td>
            <!-- <td>{{action.state}}</td> -->
            <td class="text-right"><span>{{action?.completionPercentage}}%</span></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</ng-template>

<p-dialog header="Log" [(visible)]="showingActionExecutionWayPoints" [style]="{'width':'75%'}" [modal]=" true"
  [appendTo]="'body'" [responsive]="true">
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
    <div class="container-fluid m-b-lg ">
      <div class="row m-t-sm ">
        <div class="col-12" *ngIf="selectedActionExecution">
          <p-table #dt [value]="selectedActionExecution.waypoints" [resizableColumns]="true" [responsive]="true"
            [paginator]="false" dropdownAppendTo="body">
            <ng-template pTemplate="header">
              <tr>
                <th class="DATETIMETH">Fecha</th>
                <th class="TEXTTH">Texto</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-waypoint>
              <tr>
                <td class="DATETIME">{{waypoint.eventDate | date: DATEPIPE_DATETIME_FORMAT}}</td>
                <td class="TEXT" pTooltip="{{waypoint.message}}">{{waypoint.message}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="2">No hay logs disponibles</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>